<template>
  <Category cate-name="hobby" category-name="趣味・娯楽" />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
